import React, {Component} from "react";
import {Glob as G} from "../../libs/Glob.mjs";

const prefix="MeteoCanvas";

const makeGraph = async ( canvas, data ) => {
	const ratio = window.devicePixelRatio;
	const totWidth = Math.round(canvas.getBoundingClientRect().width * ratio);
	const totHeight = Math.round(canvas.getBoundingClientRect().height * ratio);
	canvas.setAttribute( "width", String(totWidth) );
	canvas.setAttribute( "height", String(totHeight) );
	const ctx = canvas.getContext("2d");
	ctx.reset();
	ctx.clearRect(0, 0, totWidth, totHeight);
	const points = [];
	const maxPoints = 22;
	for (let di = 0; di < data.length && points.length < maxPoints; di++) {
		const d = data[di];
		for (let hi = 0; hi < d.hours.length && points.length < maxPoints; hi++) {
			points.push(d.hours[hi]);
		}
	}
	if ( points.length < 1 ) return;
	const maxX = points.length -.5;
	const maxTemp = Math.max(...points.map( p => p.temp ));
	const minTemp = Math.min(...points.map( p => p.temp ));
	const maxApp = Math.max(...points.map( p => p.app ));
	const minApp = Math.min(...points.map( p => p.app ));
	const graphMinTemp = Math.round(Math.min(-1, minTemp, minApp ) -1); // at least -2
	const graphMaxTemp = Math.round(Math.max(8, maxTemp, maxApp) +2); // at least 10
	const graphTempRange = graphMaxTemp - graphMinTemp;
	const graphHeight = 89; // It's % of height
	const graphHeightRatio = (totHeight * graphHeight) / (graphTempRange * 100);
	const px = x => Math.round( x * totWidth / 100);
	const py = y => Math.round( y * totHeight / 100);
	const gx = x => Math.round( px(6) + (totWidth -px(8)) * ( x / maxX ));
	const gy = y => Math.round( ( graphMaxTemp - y) * graphHeightRatio );
	const hours = [];
	const font = ctx._font(String(11 * ratio)+'px Verdana');
	ctx._font( font.toString() ).draw();
	hours.push(
		ctx._line( 2 * ratio )
			.width(ratio).color('#999')
			.from(gx(1),gy(Math.min(0,points[1]?.temp,points[1]?.app)))
			.to(gx(1),gy(Math.max(0,points[1]?.temp,points[1]?.app)))
	);
	const tcurve = ctx._line().width( 3 * ratio ).color("#9c9").from(gx(0),gy( points[0].temp ));
	const acurve = ctx._line().width( 3 * ratio ).color("#ccc").from(gx(0),gy( points[0].app ));
	const circles = [];
	const bars = [];
	let ppcount = 0;
	points.forEach( (p,i) => {
		if ( i === 0) return;
		const x = gx(i);
		const t = ctx._text(String(p.hour).padStart(2,'0'), x, gy(0)+(10 * ratio));
		if ( i === 1 ) {
			t.color('#000').font( font.bold().toString() );
		} else {
			t.font( font.size( 10 * ratio ).normal().toString() ).color('#666');
		}
		hours.push( t.align('center').valign('middle').fill() );
		tcurve.to( x, gy( p.temp ));
		acurve.to( x, gy( p.app ));
		circles.push(ctx._circle( gx(i), gy(p.app), ( 4 * ratio)).fill( p.app === maxApp ? '#c99' : (p.app === minApp ? '#99c' : '#ccc')));
		circles.push(ctx._circle( gx(i), gy(p.temp), ( (i === 1 ? 8 : 4 ) * ratio)).fill( p.temp === maxTemp ? '#c00' : (p.temp === minTemp ? '#00c' : '#9c9')));
		if ( p.pp ) {
			ppcount++;
			const top = gy(p.pp * graphMaxTemp / 100 );
			const h = gy(0) - top;
			bars.push( ctx._square( gx(i - .5), top, gx(1) -gx(0), h ) );
		}
	});
	bars.forEach( bar => {
		bar.gradienth('#EBFFEECC','#78D0F6A5').draw();
	});
	acurve.draw();
	tcurve.draw();
	circles.forEach( c => { c.draw() });
	hours.push( ctx._line().from(gx(0),gy(0)).to(gx(maxX),gy(0)).width(ratio) );
	hours.push( ctx._line().from(gx(0),gy(graphMinTemp)).to(gx(0),gy(graphMaxTemp)).width(ratio) );
	ctx._text('°C', px(0), px(0)).color('#333').align('left').valign('top').fill().draw();
	for ( let i = Math.ceil(graphMinTemp / 2) *2; i < graphMaxTemp; i+=2 ) {
		ctx._text(String(i), gx(0)-px(1), gy(i)).color('#999').align('right').valign('middle').fill().draw();
	}
	ctx._font(String(12 * ratio)+'px Verdana').draw();
	hours.forEach( ht => ht.draw() );
	const base = py(graphHeight + 4);
	const ws = ( maxPoints -3 ) /3;
	const w = gx( ws ) - gx(0);
	ctx._line().from(gx(0),base).to(gx(0) + w,base).width( 3 * ratio ).color("#9c9").draw();
	ctx._text(G.label("Temperature"),gx(ws / 2),base + py(1), w).valign("top").align("center").fill().draw();
	ctx._line().from(gx(ws +1),base).to(gx(ws +1) + w,base).width( 3 * ratio ).color("#ccc").draw();
	ctx._text(G.label("Perceived"),gx(ws * 1.5 +1),base + py(1), w).valign("top").align("center").fill().draw();
	if ( ppcount ) {
		ctx._square( gx(2 * ws +2), base - py(1), w, py(8) ).gradienth('#EBFFEECC','#78D0F6A5').draw();
		ctx._text("% "+G.label("Rain"),gx(ws * 2.5 +2),base + py(1), w).valign("top").align("center").fill().draw();
	}
};

const MeteoCanvas = class extends Component {
	constructor(props) {
		super(props);
		this.state = {}
		this.uid = G.generateUid(prefix);
		this.update = this.update.bind(this);
	}
	componentDidMount() {
		this.update();
	}
	componentDidUpdate(prevProps) {
		if ( typeof prevProps?.hour !== 'undefined' && prevProps?.hour !== this.props.hour ) this.update();
	}
	update() {
		const canvas = window.document.getElementById(this.uid);
		if ( ! canvas || this.state.plotting ) return;
		this.setState({plotting: true}, ()=>{
			makeGraph(canvas, this.props.data).catch( e => {
				console.error(e);
				console.debug('DATA',this.props.data);
			}).finally( () => {
				this.setState({ plotting: false })
			});
		});
	}
	render() {
		return (
			<canvas
				onClick={ ()=>{ if (G.getCurrentPage()?.name !== 'Meteo' ) G.gotoPage({name:'Details',params:{pane:'meteo'}}) } }
				id={this.uid}
			/>
		)
	}
}

export default MeteoCanvas;